import React, { useState, useEffect } from 'react';
import { get_basic_info } from '../../services/common';
import moment from 'moment';

const SecuritiesBasic = ({ fumId }) => {
  const [basic, setBasic] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fumId) {
      getBasicInfo();
    }
  }, [fumId]);

  const getBasicInfo = async () => {
    try {
      // const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}'); // Fixed: Changed variable name
      // const userToken = localData['access-token']; // Fixed: Updated reference
      const userToken = localStorage.getItem('systemToken') || "";
      const response = await get_basic_info(userToken, fumId);
      
      if (response.success === 200) {
        setBasic(response.basic);
      }
    } catch (error) {
      console.error('Error fetching basic info:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full m-0">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full m-0">
      <div className="w-full">
        {/* First Row */}
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Liability Balance
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.liability_balance !== 'undefined' 
                ? basic.liability_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Total Paid By Investors
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.investor_paid !== 'undefined' 
                ? basic.investor_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Total Principle Paid
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.principle_paid !== 'undefined' 
                ? basic.principle_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Balance
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.balance !== 'undefined' 
                ? basic.balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-12 gap-0 mt-2">
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Coupon Due
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.coupon_due !== 'undefined' 
                ? basic.coupon_due.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Total Acquisition
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.total_acquisition !== 'undefined' 
                ? basic.total_acquisition.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Not Invested
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.not_invested !== 'undefined' 
                ? basic.not_invested.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Growth*
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.growth}
            </p>
          </div>
        </div>

        {/* Third Row */}
        <div className="grid grid-cols-12 gap-0 mt-2">
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              ROI
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.roi}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              IRR
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.irr}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritiesBasic;
